import { scan } from 'react-scan'
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './root/App/App';
import '../src/assets/styles/index.scss';
import "./i18n";
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(weekday);
dayjs.extend(localeData);

import store from '../config/store';
import GlobalError from './root/App/GlobalError';

scan({
  enabled: false,
  log: true,
  showToolbar: true,
})

ReactDOM.render(
  // <React.StrictMode>
    <Provider store={store}>
      <App />
      <GlobalError />
    </Provider>,
  // </React.StrictMode>,
    //
  document.getElementById('root'),
);
 
if (module.hot) {
    module.hot.accept()
  }
  
